import Typography from 'antd/es/typography/Typography';
import { Row } from 'antd';
import styled from 'styled-components';

const Container = styled.div`
  margin: 10px;
`;

function EmptyItem({ message }) {
  return (
    <Container className="no-move">
      <Row style={{ padding: '10px 0' }}>
        <Typography.Text>{message}</Typography.Text>
      </Row>
    </Container>
  );
}

export default EmptyItem;
